$(document).ready(function () {
	$(document).on('click', '[data-qty]', function () {
		let $self = $(this),
			$container = $self.closest('[data-cart="qty"]'),
			$input = $container.find('input'),
			value = parseFloat($input.val()),
			max = parseInt($input.attr('max')),
			step = parseFloat($container.data('step')) || 1,
			btn = $self.attr('data-qty'),
			unRemove = $container.data('unremove') || false;

		if (btn === 'trash') return true;

		let price = $container.data('price');
		let result = inputQtyResult(value, btn, step, 1);
		let price_total = result * price;

		if (!isNaN(max)) {
			if (result <= max) {
				if (result > step) {
					$input.val(result);
				} else {
					$input.val(step);
				}
			} else {
				$input.val(max);

				let text = $container.data('max-text');
				if (text) {
					text = text.replace(':cnt', max);
					alert(text)
				}
			}
		} else {
			$input.val(result);
		}

		if (max && max === result) {
			$input.addClass('is-max');
		} else {
			$input.removeClass('is-max');
		}

		if (result === step || result === 0 || result < step) {
			if (!unRemove) {
				$container.find('button').first().attr('data-qty', 'trash');
			}
		} else {
			$container.find('button').first().attr('data-qty', 'minus');
		}

		if (result) {
			$container.trigger('change-counter', {
				count: result,
				price_total: price_total
			});
		}

		return false;
	});

	function inputQtyResult(val, sign = '', step = 1, fixed = 0) {
		let result = step;

		if (sign && (sign === 'plus' || sign === 'minus')) {
			if (sign === 'plus') result = val + step;
			if (sign === 'minus') result = val - step;
			if (fixed > 0) result = result.toFixed(fixed);
		}

		return parseFloat(result);
	}

	$(document).on('blur', 'input[name="total"]', function () {
		let $self = $(this),
			max = parseFloat($self.attr('max')),
			value = parseFloat($self.val());

		if (value > max) {
			$('[data-qty="plus"]').trigger('click');
		}

		if (value === 0 || value < 0) {
			$self.val(1)
		}

		return false;
	});
});
